<div class="row row-sm add-form min">
  <div class="col-lg-12 ">
    <div class="card-body">
      <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
        <div class="ml-2">
          <h3 class="main-content-label mb-1"><b>
            {{'header.course-data.title' | translate }}
            </b></h3>
          <p class="text-muted card-sub-title mb-0">
            {{'header.course-data.titleList.AddNewCourseRecord' | translate }}
          </p>
        </div>
      </div>
      <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
        <div class="ml-2">
          <h3 class="main-content-label mb-1"><b>
            {{'header.course-data.title' | translate }}
            </b></h3>
          <p class="text-muted card-sub-title mb-0">
            {{'header.course-data.titleList.UpdateCourseRecord' | translate }}
          </p>
        </div>
      </div>
      <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
        <div class="ml-2">
          <h3 class="main-content-label mb-1"><b>
            {{'header.course-data.title' | translate }}
            </b></h3>
          <p class="text-muted card-sub-title mb-0">
            {{'header.course-data.titleList.DeleteCourseRecord' | translate }}
          </p>
        </div>
      </div>
      <div class="row row-sm add-form">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)" [selectedIndex]="selectedIndex"
          mat-stretch-tabs="false" mat-align-tabs="start" class="mt-3">
          <mat-tab label="Course">

            <div (next)="next()">
              <form autocomplete="off" class="p-0" novalidate [formGroup]="courseForm">
                <div class="col-lg-12 col-md-12 prpl">
                  <div class="card-body ">
                    <div class="row clearfix">
                      <div class="col-sm-2">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>{{'header.course-data.titleList.ProgramCode' | translate }}</mat-label>
                              <input onkeydown="return (event.keyCode!=13);" required appUppercase
                                [readonly]="isReadonly || isDeleteReadonly" maxlength="5" style="color:black;" matInput
                                formControlName="CoCode" placeholder="Course Code">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoCode'].touched && courseForm.controls['CoCode'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoCode'].touched && courseForm.controls['CoCode'].errors?.pattern">
                                Invalid
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>{{'header.faculty-data.titleList.Faculty'| translate }}</mat-label>
                              <mat-select [disabled]="isDeleteReadonly" required #select33 placeholder="CoFcCode"
                                class="colorblack" formControlName="CoFcCode">
                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                  [displayMember]="'FcDesc'" [array]="fcCodeList"
                                  (filteredReturn)="filteredListFcCode =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode">
                                  {{item.FcCode}} - {{item.FcDesc}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoFcCode'].touched && courseForm.controls['CoFcCode'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoMediums'][0]['FormVisible']">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoMediums'][0]['FormDisplayName']}}
                              </mat-label>
                              <mat-select [required]="CourseFormArray['CoMediums'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select22 class="colorblack" formControlName="CoMediums"
                                multiple>
                                <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseMediumList"
                                  (filteredReturn)="filteredCourseMediumList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseMediumList" [value]="item.CdCode">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoMediums'].touched && courseForm.controls['CoMediums'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoRgPrfx'][0]['FormVisible']">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                Rg No Prefix </mat-label>
                              <input [required]="CourseFormArray['CoRgPrfx'][0]['FormRequired']" (input)="rollNoPrefix($event.target.value)"
                                onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" maxlength="5" matInput formControlName="CoRgPrfx"
                                placeholder="Course Roll No. Prefix">
                              <!-- <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoRgPrfx'].touched && courseForm.controls['CoRgPrfx'].errors?.required">
                                Mandatory
                              </mat-error> -->
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoRgPrfx'].touched && courseForm.controls['CoRgPrfx'].errors?.pattern">
                                Invalid
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                               Roll No Prefix</mat-label>
                              <input onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" minlength="2" maxlength="5" matInput formControlName="RollNoPrfx"
                                placeholder="Course Roll No. Prefix">
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>
                            {{'header.course-data.titleList.Name'| translate }}</mat-label>
                          <input appCamelcase onkeydown="return (event.keyCode!=13);" required style="color:black;" maxlength="80"
                            [readonly]="isDeleteReadonly" matInput formControlName="CoName" placeholder="Course Name">
                          <mat-error class="margin_tp"
                            *ngIf="courseForm.controls['CoName'].touched && courseForm.controls['CoName'].errors?.required">
                            Mandatory
                          </mat-error>
                         
                        </mat-form-field>
                      </div>
                      <div class="col-sm-3">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{'header.course-data.titleList.NoOfYears' | translate }}</mat-label>
                              <input (change)="checkmaxyears1()" onkeydown="return (event.keyCode!=13);"
                                [readonly]="isDeleteReadonly" style="color:black;" maxlength="2" matInput
                                formControlName="CoYears" placeholder="No. Of Years" required>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoYears'].touched && courseForm.controls['CoYears'].errors?.pattern">
                                Invalid
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoYears'].touched && courseForm.controls['CoYears'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{'header.course-data.titleList.NoOfExams'| translate }}</mat-label>
                              <input required onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" maxlength="2" matInput formControlName="CoExams"
                                placeholder="No. Of Exams">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoExams'].touched && courseForm.controls['CoExams'].errors?.pattern">
                                Invalid
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoExams'].touched && courseForm.controls['CoExams'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoPattern'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoPattern'][0]['FormDisplayName']}}
                              </mat-label>
                              <mat-select [required]="CourseFormArray['CoPattern'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select333 placeholder="CoPattern" class="colorblack"
                                formControlName="CoPattern">
                                <mat-select-filter *ngIf="select333.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="coursePatternList"
                                  (filteredReturn)="filteredCoursePatternList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCoursePatternList" [value]="item.CdCode">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPattern'].touched && courseForm.controls['CoPattern'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 mt-2 hidden" *ngIf="CourseFormArray['CoCBCS'][0]['FormVisible']">
                        <div class="">
                          <div class="row">
                            <div class="col-sm-4">
                              <mat-label class="lclass">
                                {{CourseFormArray['CoCBCS'][0]['FormDisplayName']}}
                              </mat-label>
                            </div>
                            <div class="col-sm-8">
                              <mat-radio-group [required]="CourseFormArray['CoCBCS'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" formControlName="CoCBCS" class="example-full-width">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <mat-radio-button value='Y'>Yes</mat-radio-button>
                                  </div>
                                  <div class="col-sm-5">
                                    <mat-radio-button value='N'>No</mat-radio-button>
                                  </div>
                                </div>
                                <mat-error class="margin_tp"
                                  *ngIf="courseForm.controls['CoCBCS'].touched && courseForm.controls['CoCBCS'].errors?.required">
                                  Mandatory
                                </mat-error>
                              </mat-radio-group>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 " *ngIf="CourseFormArray['CoEval'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoEval'][0]['FormDisplayName']}}
                              </mat-label>
                              <mat-select [required]="CourseFormArray['CoEval'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select440 class="colorblack" formControlName="CoEval">
                                <mat-select-filter *ngIf="select440.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseEvaluationList"
                                  (filteredReturn)="filteredCourseEvaluationList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseEvaluationList" [value]="item.CdCode">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoEval'].touched && courseForm.controls['CoEval'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoMaxYr'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoMaxYr'][0]['FormDisplayName']}}
                              </mat-label>
                              <input [required]="CourseFormArray['CoMaxYr'][0]['FormRequired']"
                              (change)="checkmaxyears()" onkeydown="return (event.keyCode!=13);"
                                [readonly]="isDeleteReadonly" style="color:black;" maxlength="2" matInput
                                formControlName="CoMaxYr" placeholder="Course Maximum Years">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoMaxYr'].touched && courseForm.controls['CoMaxYr'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                              *ngIf="courseForm.controls['CoMaxYr'].touched && courseForm.controls['CoMaxYr'].errors?.pattern">
                              Invalid
                            </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2" *ngIf="CourseFormArray['CoPassPC'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoPassPC'][0]['FormDisplayName']}} </mat-label>
                              <input [required]="CourseFormArray['CoPassPC'][0]['FormRequired']"
                                onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" step="0.01" maxlength="5" matInput formControlName="CoPassPC"
                                placeholder="Pass %">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPassPC'].touched && courseForm.controls['CoPassPC'].errors?.max">
                                Max 100%
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPassPC'].touched && courseForm.controls['CoPassPC'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2 hidden" *ngIf="CourseFormArray['CoPassCR'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoPassCR'][0]['FormDisplayName']}}
                              </mat-label>
                              <input [required]="CourseFormArray['CoPassCR'][0]['FormRequired']"
                                onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" maxlength="7" step="0.01" matInput formControlName="CoPassCR"
                                placeholder="Pass Credits">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPassCR'].touched && courseForm.controls['CoPassCR'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPassCR'].touched && courseForm.controls['CoPassCR'].errors?.max">
                                Less Than 5000
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoPassCR'].touched && courseForm.controls['CoPassCR'].errors?.pattern">
                                Invalid
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2" *ngIf="CourseFormArray['CoGPAm'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoGPAm'][0]['FormDisplayName']}}</mat-label>
                              <mat-select [required]="CourseFormArray['CoGPAm'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select550 class="colorblack" formControlName="CoGPAm">
                                <mat-select-filter *ngIf="select550.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseGradeMarkList"
                                  (filteredReturn)="filteredCourseGradeMarkList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseGradeMarkList" [value]="item.CdCode ">
                                  {{item.CdDesc }}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoGPAm'].touched && courseForm.controls['CoGPAm'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoRule'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoRule'][0]['FormDisplayName']}}
                              </mat-label>
                              <mat-select [required]="CourseFormArray['CoRule'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select444 class="colorblack" formControlName="CoRule">
                                <mat-select-filter *ngIf="select444.focused" [placeholder]="'Filter'"
                                  [displayMember]="'RuRule'" [array]="courseRulesList"
                                  (filteredReturn)="filteredCourseRulesList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseRulesList" [value]="item.RuRule ">
                                  {{item.RuRule }}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoRule'].touched && courseForm.controls['CoRule'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                       <div class="col-sm-3" *ngIf="CourseFormArray['CourseLevel'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CourseLevel'][0]['FormDisplayName']}}
                              </mat-label>
                              <mat-select [required]="CourseFormArray['CourseLevel'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select444 class="colorblack" formControlName="CourseLevel">
                                <mat-select-filter *ngIf="select444.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseLevelList"
                                  (filteredReturn)="filteredCourseLevelList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseLevelList" [value]="item.CdCode">
                                  {{item.CdDesc }}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CourseLevel'].touched && courseForm.controls['CourseLevel'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoProgCGPA'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoProgCGPA'][0]['FormDisplayName']}}
                              </mat-label>
                              <input [required]="CourseFormArray['CoProgCGPA'][0]['FormRequired']"
                                onkeydown="return (event.keyCode!=13);" [readonly]="isDeleteReadonly"
                                style="color:black;" maxlength="5" step="0.01" matInput formControlName="CoProgCGPA"
                                placeholder="Progr CGPA">
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoProgCGPA'].touched && courseForm.controls['CoProgCGPA'].errors?.required">
                                Mandatory
                              </mat-error>
                              <mat-error class="margin_tp"
                              *ngIf="courseForm.controls['CoProgCGPA'].touched && courseForm.controls['CoProgCGPA'].errors?.pattern">
                              Invalid
                            </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3" *ngIf="CourseFormArray['CoSpSub'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>{{CourseFormArray['CoSpSub'][0]['FormDisplayName']}}</mat-label>
                              <mat-select [required]="CourseFormArray['CoSpSub'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select44 class="colorblack" formControlName="CoSpSub">
                                <mat-select-filter *ngIf="select44.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseScaleList"
                                  (filteredReturn)="filteredCourseScaleList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseScaleList" [value]="item.CdCode">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoSpSub'].touched && courseForm.controls['CoSpSub'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2 mtt" *ngIf="CourseFormArray['CoRelGrd'][0]['FormVisible']">
                        <div class="form-group">
                          <mat-checkbox [required]="CourseFormArray['CoRelGrd'][0]['FormRequired']"
                            formControlName="CoRelGrd" class="example-full-width ">
                            {{CourseFormArray['CoRelGrd'][0]['FormDisplayName']}}
                          </mat-checkbox>
                          <mat-error class="margin_tp"
                            *ngIf="courseForm.controls['CoRelGrd'].touched && courseForm.controls['CoRelGrd'].errors?.required">
                            Mandatory
                          </mat-error>
                        </div>
                      </div>
                      <div class="col-sm-2 mtt" *ngIf="CourseFormArray['CoDebar'][0]['FormVisible']">
                        <div class="form-group">
                          <mat-checkbox [required]="CourseFormArray['CoDebar'][0]['FormRequired']"
                            formControlName="CoDebar" class="example-full-width ">
                            {{CourseFormArray['CoDebar'][0]['FormDisplayName']}}
                          </mat-checkbox>
                          <mat-error class="margin_tp"
                            *ngIf="courseForm.controls['CoDebar'].touched && courseForm.controls['CoDebar'].errors?.required">
                            Mandatory
                          </mat-error>
                        </div>
                      </div>
                      <div class="col-sm-2" *ngIf="CourseFormArray['CoGPts'][0]['FormVisible']">
                        <div class="">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                {{CourseFormArray['CoGPts'][0]['FormDisplayName']}}</mat-label>
                              <mat-select [required]="CourseFormArray['CoGPts'][0]['FormRequired']"
                                [disabled]="isDeleteReadonly" #select55 class="colorblack" formControlName="CoGPts">
                                <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseGradeList"
                                  (filteredReturn)="filteredCourseGradeList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseGradeList" [value]="item.CdCode ">
                                  {{item.CdDesc }}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoGPts'].touched && courseForm.controls['CoGPts'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                          <button id="Save" type="button" *ngIf="submitButton && CourseCreate"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1" (click)="submit()">
                            <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Save'| translate }} 
                            </span>
                          </button>
                          <button id="Update" type="button" *ngIf="editButton && CourseUpdate"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1" (click)="update()">
                            <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Update'| translate }}   
                            </span>
                          </button>
                          <button id="Delete" type="button" *ngIf="deleteButton && CourseDelete"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                            (click)="openConformationModalBox()">
                            <span style="display: contents; align-items: center;">
                              <img width="23%" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Delete'| translate }} 
                            </span>
                          </button>
                          <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                              <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                              {{'header.course-data.titleList.Back'| translate }} 
                            </span>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </mat-tab>
          <mat-tab label="Branch/Stream" [disabled]="BranchDisabled" *ngIf="branchView">
            <app-exam-stream-data class="p-0" (prev)="prev()"></app-exam-stream-data>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>